/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useCallback, useEffect, useRef, useState } from "react";
import { convertDateToEpochUTC } from "../../../helper/DateConverters";
import { addReview } from "./fetchData";
import { Toast } from "primereact/toast";
import SignaturePadComponent from "./Add Risk Assessment/SignaturePadComponent";
import { getTodayDate } from "./helper/helperFunctions";

interface AddReviewModalProps {
  visible: boolean;
  setVisible: any;
  onHide: () => void;
  onReviewSubmitted?: () => void; // Add this line
}

const AddReviewModal: React.FC<AddReviewModalProps> = ({
  visible,
  setVisible,
  onHide,
  onReviewSubmitted, // Add this line
}) => {
  const [addReviewLoading, setAddReviewLoading] = useState(false);

  const signatureRef = useRef<any | null>(null);
  const query = new URLSearchParams(window.location.search);
  const formID = Number(query.get("formID"));

  const toast = useRef<Toast>(null);
  const [addReviewFormValues, setAddReviewFormValues] = useState<any>({
    formID: formID,
    reviewerDate: convertDateToEpochUTC(
      new Date(new Date().setHours(0, 0, 0, 0))
    ),
    reviewerName: null,
    reviewerComment: null,
  });
  const [formErrors, setFormErrors] = useState<any>({
    reviewerDate: null,
    reviewerName: null,
    reviewerSignature: null,
    reviewerComment: null,
  });

  const clearSignature = (ref: React.RefObject<any>) => {
    if (ref.current) {
      ref.current.clear();
    }
  };

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Function to clear all signatures
  const clearAllSignatures = useCallback(() => {
    // Don't clear signatures on initial load
    // if (isInitialLoad) return;

    // Clear Reviewer signature
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  }, [
    // addReviewFormValues?.rev,
    // addReviewFormValues?.teamMember2,
    // addReviewFormValues?.additionalTeamMembers,
    // isInitialLoad,
  ]);

  useEffect(() => {
    clearAllSignatures();
  }, [
    addReviewFormValues?.reviewerDate,
    addReviewFormValues?.reviewerName,
    addReviewFormValues?.reviewerComment,
  ]);

  const validateForm = () => {
    const errors: Partial<Record<string, string>> = {};
    if (!addReviewFormValues.reviewerDate) {
      errors.reviewerDate = "Date is required.";
    }
    if (!addReviewFormValues.reviewerName) {
      errors.reviewerName = "Reviewer's name is required.";
    }
    if (signatureRef.current?.isEmpty()) {
      errors.reviewerSignature = "Signature is required.";
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Signature is required.",
        life: 3000,
      });
    }
    if (!signatureRef.current?.isEmpty()) {
      setFormErrors((prev: any) => ({
        ...prev,
        reviewerSignature: null,
      }));
    }
    if (!addReviewFormValues.reviewerComment) {
      errors.reviewerComment = "Comment is required.";
    }
    setFormErrors((prev: any) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    // Add your form submission logic here
    if (!validateForm()) return;

    const response: any = await addReview(
      formID,
      addReviewFormValues,
      signatureRef,
      setAddReviewLoading,
      setVisible,
      toast
    );

    if (response && response.StatusCode === 200) {
      setAddReviewFormValues({
        reviewerDate: null,
        reviewerName: null,
        reviewerComment: null,
      });
      signatureRef.current?.clear();
      onReviewSubmitted?.(); // Call this after successful submission
    }
    setAddReviewFormValues({
      reviewerDate: null,
      reviewerName: null,
      reviewerComment: null,
    });
    signatureRef.current?.clear(); // Clear the signature canvas
    // setVisible(false); // Close the modal after submission
  };

  const footerContent = (
    <div className="tw-w-full ">
      <Button
        label="Submit"
        type="submit" // Ensure the button type is "submit"
        disabled={addReviewLoading} // Disable the button while loading
        loading={addReviewLoading} // Show loading spinner when loading
        onClick={handleFormSubmit} // Call the form submission function
        className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium tw-w-full"
      />
    </div>
  );
  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header={"Add Review"}
        visible={visible}
        onHide={onHide}
        closable
        draggable={false}
        footer={footerContent}
        style={{ margin: "0px 25px" }}
      >
        <div className="tw-flex tw-flex-col tw-gap-3 tw-w-full ">
          <div className="tw-flex  tw-flex-col tw-gap-2  tw-items-start tw-justify-start  tw-my-2 ">
            <label className="leak-label " htmlFor="teamMember1">
              Date
            </label>
            <InputText
              type="text"
              className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full lg:tw-w-[370px]"
              value={getTodayDate() ?? ""}
              readOnly
            />
          </div>
          <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-bold">Reviewer's Name</label>
            <InputText
              value={addReviewFormValues?.reviewerName ?? ""}
              className={`${
                formErrors.reviewerName
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors: any) => ({
                  ...prevErrors,
                  reviewerName: null,
                }));
                e.target.value === ""
                  ? setAddReviewFormValues((prev: any) => ({
                      ...prev,
                      reviewerName: null,
                    }))
                  : setAddReviewFormValues((prev: any) => ({
                      ...prev,
                      reviewerName: e.target.value,
                    }));
              }}
              placeholder="Enter Reviewer's Name"
            />
          </div>

          <div className="tw-mt-4">
            <label className="tw-font-bold">Comment</label>
            <InputTextarea
              value={addReviewFormValues?.reviewerComment ?? ""}
              onChange={(e) => {
                setFormErrors((prevErrors: any) => ({
                  ...prevErrors,
                  reviewerComment: null,
                }));
                setAddReviewFormValues((prev: any) => ({
                  ...prev,
                  reviewerComment: e.target.value,
                }));
              }}
              placeholder="Add Comment"
              className={`${
                formErrors.reviewerComment
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-w-full tw-mt-2`}
            />
          </div>
          <div className="tw-flex tw-flex-col tw-items-start ">
            <span className="tw-font-bold">Signature</span>
            <div className="tw-flex tw-flex-col tw-items-end tw-justify-center tw-w-full">
              <div className="tw-flex tw-items-center tw-justify-center tw-w-full">
                <SignaturePadComponent
                  ref={signatureRef}
                  penColor="black"
                  canvasProps={{
                    className: `tw-border tw-rounded tw-w-full tw-h-32 tw-bg-gray-100`,
                  }}
                />
              </div>
              <Button
                type="button"
                label="Clear"
                className="tw-mt-2 tw-bg-[#152846] tw-text-white tw-px-4 tw-py-1 tw-rounded-full tw-border-none tw-cursor-pointer"
                onClick={() => clearSignature(signatureRef)}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default AddReviewModal;
